import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { logout } from '../store/authSlice'


function PublicRoute({ children }) {
    const authen = useSelector((state) => state.auth)
    const location = useLocation()
    const accessToken = localStorage.getItem('AccessToken')
    const dispatch = useDispatch()

    useEffect(() => {
        if (authen.isAuthenticated && accessToken) {
            let now = moment().unix()
            let expire = moment(authen.user.expire_datetime_in).unix()
            // let expire = authen.user.expire_datetime_in

            if (expire) {
                let time = expire - now
                if (time <= 0) {
                    console.log('token หมดอายุ')
                    localStorage.clear()
                    dispatch(logout())
                }
            } else {
                localStorage.clear()
                dispatch(logout())
            }

        } else {
            console.log('ไม่มี auth')
        }

    }, [])

    return (authen.isAuthenticated && accessToken ? <Navigate to='/profile' /> : children);
    // return (authen.isAuthenticated && accessToken ? <Navigate to='/mentalHealthAssessment' /> : children);
}

export default PublicRoute
